// src/pages/ResetPasswordPage.js
import React, { useState } from 'react';
import { requestPasswordReset } from '../api/auth';
import {
  TextField,
  Button,
  Container,
  Typography,
  Alert,
  Box
} from '@mui/material';
import ContextHelpButton from '../components/ContextHelpButton';

export default function ResetPasswordPage() {
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [successMsg, setSuccessMsg] = useState('');
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError(null);
    setSuccessMsg('');

    try {
      await requestPasswordReset(email);
      // We don't reveal whether the email exists or not – just say link sent.
      setSuccessMsg(
        'If an account with that email exists, a reset link has been sent.'
      );
    } catch (err) {
      console.error('Password reset request failed:', err);
      setError('Unable to send reset link. Please try again later.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 6 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
        <Typography variant="h5">
          Reset Password
        </Typography>
        <ContextHelpButton section="getting-started" title="Help for password reset" />
      </Box>

      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      {successMsg && (
        <Alert severity="success" sx={{ mb: 2 }}>
          {successMsg}
        </Alert>
      )}

      <Box component="form" onSubmit={handleSubmit}>
        <TextField
          fullWidth
          label="Email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          margin="normal"
          required
        />
        <Button
          type="submit"
          variant="contained"
          disabled={submitting || !email}
          sx={{ mt: 2 }}
        >
          {submitting ? 'Sending...' : 'Send Reset Link'}
        </Button>
      </Box>
    </Container>
  );
}
